export class InterceptUtils {
  private static interceptTipCodes: string[] = ["-101", "-102", "-103", "-104", "-105"];

  public static formatErrorMessage(code: string, respcode: any, respMessage?: string) {
    if (typeof respcode === 'object') {
      const response = respcode
      respcode = response.respcode;
      respMessage = response.respMessage;
    }
    if (InterceptUtils.interceptTipCodes.indexOf(respcode) !== -1) {
      return respMessage;
    }
    return respMessage + code;
  }
}
